import React, { Component, PureComponent } from "react";
import { connect } from "react-redux";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ScrollContainer from "react-indiana-drag-scroll";
import posed from "react-pose";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import moment from "moment";
import ProductBookingTimingBox from "./ProductBookingTimingBox";

const ShakePose = posed.div({
  shake: {
    applyAtEnd: { x: 0 },
    applyAtStart: { x: -10 },
    x: 0,
    transition: {
      type: "spring",
      stiffness: 1000,
      damping: 10,
      duration: 4,
    },
  },
});
class ProductBookingSlot2 extends Component {
  constructor(props) {
    super(props);
    this.Dates_Container = React.createRef();
    this.Times_Container = React.createRef();
  }

  state = {
    selectedDate: -1,
    selectedTime: -1,
    ScrollAbleDate: false,
    ScrollAbleTime: false,
    error: false,
  };

  SetBookingError = () => {
    this.setState({ error: true });
  };

  ar_days = {
    Sun: "اﻷحد",
    Mon: "اﻷثنين",
    Tue: "الثلاثاء",
    Wed: "اﻷربعاء",
    Thu: "الخميس",
    Fri: "الجمعة",
    Sat: "السبت",
  };
  ar_months = {
    Jan: "يناير ",
    Feb: "فبراير",
    Mar: "مارس",
    Apr: "أبريل",
    May: "مايو",
    Jun: "يونيو",
    Jul: "يوليو",
    Aug: "أغسطس",
    Sep: "سبتمبر",
    Oct: "أكتوبر",
    Nov: "نوفمبر",
    Dec: "ديسمبر",
  };

  removeDups = (names) => {
    let unique = {};
    names.forEach(function (i) {
      if (!unique[i]) {
        unique[i] = true;
      }
    });
    return Object.keys(unique);
  };

  getDefaultDate = () => {
    if (this.props.editedProduct || this.props.prevStateBookingSlot) {
      const bookingSlot = this.props.current_product.booking_slots.find(
        (bs) =>
          bs.id ===
          (this.props.editedProduct?.booking_slot ||
            this.props.prevStateBookingSlot),
      );
      if (bookingSlot) {
        return new Date(bookingSlot.booking_date);
      }
    }
    return undefined;
  };
  check_out_of_stock = (date) => {
    let mydate = this.formatDate(this.dates[date]);
    let Times = this.props.current_product.booking_slots.filter(
      (date) => date.booking_date === mydate && date.inventory > 0,
    );
    if (Times.length) return true;
    return false;
  };

  removeEmpty = (date, i) => {
    let mydate = this.formatDate(date);
    const { editedProduct } = this.props;
    let Times = this.props.current_product.booking_slots
      .sort((a, b) => {
        if (a.booking_date < b.booking_date) return -1;
        if (a.booking_date > b.booking_date) return 1;
        if (a.start < b.start) return -1;
        if (a.start > b.start) return 1;
        return 0;
      })
      .filter(
        (date) =>
          date.booking_date === mydate &&
          (date.inventory > 0 || editedProduct?.booking_slot === date.id),
      );

    if (Times.length) return false;

    this.dates.splice(i, 1);

    return true;
  };
  handleDateChange = (date) => {
    let selectedTime = -1;
    let newError = this.state.error;
    if (date !== this.state.selectedDate) {
      let mydate = this.formatDate(this.dates[parseInt(date)]);

      let Times = this.props.current_product.booking_slots
        .sort((a, b) => {
          if (a.booking_date < b.booking_date) return -1;
          if (a.booking_date > b.booking_date) return 1;
          if (a.start < b.start) return -1;
          if (a.start > b.start) return 1;
          return 0;
        })
        .filter((date) => date.booking_date === mydate);

      if (Times.length === 1) {
        selectedTime = Times[0].id;
        newError = false;
      }

      this.props.SetBookingSlot(selectedTime);
      this.setState({
        selectedDate: parseInt(date),
        selectedTime: selectedTime,
        error: newError,
      });
    }
  };
  handleTimeChange = (Time, id) => {
    if (id !== this.state.selectedTime) {
      this.props.SetBookingSlot(id);
      this.setState({
        selectedTime: parseInt(id),
        error: false,
      });
    }
  };
  componentDidUpdate(prevProps) {
    if (
      prevProps.current_product.id !== this.props.current_product.id ||
      this.props.bookingslot == "reset"
    ) {
      this.setUpBookingSlots(true);
    }
    if (this.Dates_Container.current && this.Times_Container.current) {
      let CheckScrollAbleDate =
        this.Dates_Container.current.container.current.scrollWidth >
        this.Dates_Container.current.container.current.clientWidth;
      let CheckScrollAbleTime =
        this.Times_Container.current.container.current.scrollWidth >
        this.Times_Container.current.container.current.clientWidth;
      if (
        CheckScrollAbleDate !== this.state.ScrollAbleDate ||
        CheckScrollAbleTime !== this.state.ScrollAbleTime
      ) {
        this.setState({
          ScrollAbleDate: CheckScrollAbleDate,
          ScrollAbleTime: CheckScrollAbleTime,
        });
      }
    }
  }
  setUpBookingSlots(errorFuncionSet = false) {
    this.dates = this.removeDups(
      this.props.current_product.booking_slots
        .sort((a, b) => {
          if (a.booking_date < b.booking_date) return -1;
          if (a.booking_date > b.booking_date) return 1;
          if (a.start < b.start) return -1;
          if (a.start > b.start) return 1;
          return 0;
        })
        .map((date) => this.toDate(date.booking_date)),
    );

    this.dates.forEach((date, i) => this.removeEmpty(date, i));
    for (let i = 0; i < this.dates.length; i++) {
      if (this.removeEmpty(this.dates[i], i)) i -= 1;
    }

    if (!this.props.editedProduct) {
      if (this.dates.length) {
        let newBookingSlot = -1;
        if (this.props.prevStateBookingSlot) {
          newBookingSlot =
            this.props.current_product.booking_slots
              .sort((a, b) => {
                if (a.booking_date < b.booking_date) return -1;
                if (a.booking_date > b.booking_date) return 1;
                if (a.start < b.start) return -1;
                if (a.start > b.start) return 1;
                return 0;
              })
              .find(
                (slot) =>
                  slot.inventory > 0 &&
                  slot.id === this.props.prevStateBookingSlot,
              )?.id || -1;
        }

        this.props.SetBookingSlot(newBookingSlot);
      } else {
        this.props.SetBookingSlot("Out");
      }
    }
    if (!errorFuncionSet) {
      this.props.SetBookingError(() => this.SetBookingError());
    }
    this.setState({
      selectedDate: -1,
    });
  }
  componentDidMount() {
    this.setUpBookingSlots();
    if (this.props.editedProduct || this.props.prevStateBookingSlot) {
      const bookingSlot = this.props.current_product.booking_slots.find(
        (bs) =>
          bs.id ===
          (this.props.editedProduct?.booking_slot ||
            this.props.prevStateBookingSlot),
      );
      if (bookingSlot) {
        const bookStr = this.toDate(bookingSlot.booking_date);
        const dateSlot = this.dates.findIndex((date) => date == bookStr);
        this.setState({
          selectedDate: dateSlot,
          selectedTime:
            this.props.editedProduct?.booking_slot ||
            this.props.prevStateBookingSlot,
        });
      }
    }
  }
  toDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");

    return new Date(year, month - 1, day);
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  getDefaultActiveStartDate = () => {
    const months = this.props.current_product.booking_slots
      .sort((a, b) => {
        if (a.booking_date < b.booking_date) return -1;
        if (a.booking_date > b.booking_date) return 1;
        if (a.start < b.start) return -1;
        if (a.start > b.start) return 1;
        return 0;
      })
      .filter(
        (date) =>
          date.inventory > 0 ||
          this.props.editedProduct?.booking_slot === date.id,
      )
      .map((slot) => slot.booking_date.substring(0, 7))
      .sort();
    return new Date(months[0]);
  };
  render() {
    let DateItems = [];
    let Times = [];
    let MorningTimes = [];
    let NightTimes = [];
    let dateError = false;
    let timeError = false;
    if (this.state.error) {
      if (this.state.selectedDate === -1) {
        dateError = true;
      } else {
        timeError = true;
      }
    }
    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";

    const { language, customTexts, current_product, settings } = this.props;
    if (this.dates) {
      DateItems = this.dates.map((date, i) => {
        date = date.split(" ");
        return language === "english" ? (
          <span
            key={i}
            className={` pointer ${
              this.state.selectedDate === i ? "active" : ""
            }`}
            onClick={() => this.handleDateChange(i)}
            style={{
              color: this.state.selectedDate === i && themeColor,
              border: `1px solid ${
                this.state.selectedDate === i ? themeColor : "#99999999"
              }`,
              borderRadius: 5,
              padding: 15,
            }}
          >
            {`${date[0]}  ${parseInt(date[2], 10)}  ${date[1]}`}
          </span>
        ) : (
          <span
            key={i}
            className={` pointer  ${
              this.state.selectedDate === i ? "active" : ""
            }`}
            onClick={() => this.handleDateChange(i)}
            style={{
              color: this.state.selectedDate === i && themeColor,
              border: `1px solid ${
                this.state.selectedDate === i ? themeColor : "#99999999"
              }`,
              borderRadius: 5,
              padding: 15,
            }}
          >
            {`${this.ar_days[date[0]]}  ${parseInt(date[2], 10)} ${
              this.ar_months[date[1]]
            }`}
          </span>
        );
      });

      let mydate = this.formatDate(this.dates[this.state.selectedDate]);
      this.props.current_product.booking_slots
        .sort((a, b) => {
          if (a.booking_date < b.booking_date) return -1;
          if (a.booking_date > b.booking_date) return 1;
          if (a.start < b.start) return -1;
          if (a.start > b.start) return 1;
          return 0;
        })
        .filter(
          (date) =>
            date.booking_date === mydate &&
            (date.inventory > 0 ||
              this.props.editedProduct?.booking_slot != date.booking_slot),
        )
        .forEach((time, i) => {
          if (current_product.time_slots_style === 3) {
            {
              time.all_day
                ? Times.push(
                    <ProductBookingTimingBox
                      time={time}
                      key={i}
                      handleTimeChange={this.handleTimeChange}
                      onClick={() => this.handleTimeChange(i, time.id)}
                      current_product={current_product}
                      selectedTime={this.state.selectedTime}
                    />,
                  )
                : moment(time.start, "HH:mm:ss").format("h:mm A").includes("AM")
                  ? MorningTimes.push(
                      <ProductBookingTimingBox
                        time={time}
                        key={i}
                        handleTimeChange={this.handleTimeChange}
                        onClick={() => this.handleTimeChange(i, time.id)}
                        current_product={current_product}
                        selectedTime={this.state.selectedTime}
                      />,
                    )
                  : NightTimes.push(
                      <ProductBookingTimingBox
                        time={time}
                        key={i}
                        handleTimeChange={this.handleTimeChange}
                        onClick={() => this.handleTimeChange(i, time.id)}
                        current_product={current_product}
                        selectedTime={this.state.selectedTime}
                      />,
                    );
            }
          } else {
            Times.push(
              <ProductBookingTimingBox
                time={time}
                key={i}
                handleTimeChange={this.handleTimeChange}
                onClick={() => this.handleTimeChange(i, time.id)}
                current_product={current_product}
                selectedTime={this.state.selectedTime}
              />,
            );
          }
        });
    }

    if (this.dates && this.dates.length)
      return (
        <div
          id="BookingSlots"
          className="border-top border-bottom mt-3"
          style={{ width: "100%", backgroundColor: "white" }}
        >
          <ShakePose
            pose={[`${dateError ? "shake" : ""}`]}
            poseKey={dateError === false}
          >
            {" "}
            <h4
              className={`mt-4  ${
                language === "english" ? "text-left" : "text-right"
              } mx-4`}
              style={{
                fontFamily: language == "english" ? "Quicksand" : "Cairo",
                color: dateError ? "red" : "",
              }}
            >
              {`${
                language === "english"
                  ? customTexts.bookables_select_date
                  : customTexts.bookables_select_date_ar
              }`}
            </h4>
          </ShakePose>
          <div
            className={`d-flex ${
              current_product.service_booking_style !== "calendar" ? "mt-4" : ""
            } mx-auto align-items-center ${
              this.state.ScrollAbleDate
                ? "justify-content-start"
                : "justify-content-center"
            }   `.concat(
              current_product.service_booking_style !== "calendar"
                ? " border-top border-bottom"
                : "",
            )}
            style={{
              width:
                this.props.current_product.service_booking_style == "calendar"
                  ? "100%"
                  : "90%",
              heigth: "70px",
              color: "#999",
              fontSize: "15px",
              fontFamily: "",
              fontWeight: "600",
              overflowX: "auto",
              whiteSpace: "nowrap",
            }}
          >
            <div style={{ height: "auto" }}>
              {this.state.ScrollAbleDate && (
                <ArrowBackIosIcon
                  className="pointer"
                  onClick={() =>
                    (this.Dates_Container.current.container.current.scrollLeft +=
                      -100)
                  }
                />
              )}
            </div>
            <ScrollContainer
              className={` d-flex  ${
                current_product.service_booking_style !== "calendar"
                  ? "py-3"
                  : "pt-3"
              }   ${language === "arabic" ? "flex-row-reverse" : ""}`}
              ref={this.Dates_Container}
              style={{ gap: 8 }}
            >
              {this.props.current_product.service_booking_style ==
              "calendar" ? (
                <Calendar
                  defaultActiveStartDate={this.getDefaultActiveStartDate()}
                  defaultValue={this.getDefaultDate()}
                  onChange={(date) => {
                    this.handleDateChange(
                      this.dates.findIndex((d) => d == date.toString()),
                    );
                  }}
                  calendarType="Arabic"
                  tileDisabled={({ activeStartDate, date, view }) => {
                    const localDate =
                      date.getFullYear() +
                      "-" +
                      String(date.getMonth() + 1).padStart(2, "0") +
                      "-" +
                      String(date.getDate()).padStart(2, "0");
                    return !this.props.current_product.booking_slots
                      .sort((a, b) => {
                        if (a.booking_date < b.booking_date) return -1;
                        if (a.booking_date > b.booking_date) return 1;
                        if (a.start < b.start) return -1;
                        if (a.start > b.start) return 1;
                        return 0;
                      })
                      .filter(
                        (date) =>
                          date.inventory > 0 ||
                          this.props.editedProduct?.booking_slot === date.id,
                      )
                      .map((slot) => slot.booking_date)
                      .includes(localDate);
                  }}
                  locale={language == "english" ? "en" : "ar-KW"}
                />
              ) : (
                DateItems
              )}
            </ScrollContainer>
            {this.state.ScrollAbleDate && (
              <div style={{ height: "auto" }}>
                <ArrowForwardIosIcon
                  className="ml-1 my-auto pointer"
                  onClick={() =>
                    (this.Dates_Container.current.container.current.scrollLeft += 100)
                  }
                />
              </div>
            )}
          </div>
          <ShakePose
            pose={[`${timeError ? "shake" : ""}`]}
            poseKey={timeError === false}
          >
            {" "}
            <h4
              className={`${
                current_product.service_booking_style !== "calendar"
                  ? "mt-4"
                  : ""
              }  ${language === "english" ? "text-left" : "text-right"} mx-4`}
              style={{
                fontFamily: language == "english" ? "Quicksand" : "Cairo",
                color: timeError ? "red" : "",
              }}
            >
              {`${
                language === "english"
                  ? customTexts.bookables_select_time
                  : customTexts.bookables_select_time_ar
              }`}
            </h4>
          </ShakePose>
          <div
            className={`mt-4 mx-auto align-items-center mb-5 ${
              this.state.ScrollAbleTime
                ? "justify-content-start"
                : "justify-content-center"
            } 
           `.concat(
              current_product.time_slots_style === 0
                ? " border-top border-bottom d-flex"
                : "",
            )}
            style={{
              width: "90%",
              heigth: "70px",
              color: "#999",
              fontSize: "15px",
              fontFamily: "",
              fontWeight: "600",
              overflowX: "auto",
              whiteSpace: "nowrap",
            }}
          >
            {current_product.time_slots_style === 0 && (
              <div style={{ height: "auto", gap: 4 }}>
                {this.state.ScrollAbleTime &&
                  this.state.selectedDate !== -1 && (
                    <ArrowBackIosIcon
                      className="pointer"
                      onClick={() =>
                        (this.Times_Container.current.container.current.scrollLeft +=
                          -100)
                      }
                    />
                  )}
              </div>
            )}

            {current_product.time_slots_style === 0 && (
              <ScrollContainer
                className={` d-flex  py-3 ${
                  language === "arabic" ? "flex-row-reverse" : ""
                } `}
                ref={this.Times_Container}
                style={{ gap: 8 }}
              >
                {Times.length
                  ? Times
                  : language === "english"
                    ? "Select your date first"
                    : "يجب إختيار التاريخ اولا"}
              </ScrollContainer>
            )}
            {current_product.time_slots_style === 1 &&
              (!Times.length ? (
                language === "english" ? (
                  "Select your date first"
                ) : (
                  "يجب إختيار التاريخ اولا"
                )
              ) : (
                <>
                  <div style={{ maxHeight: 200, overflowY: "scroll" }}>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "auto",
                        justifyContent: "center",
                        rowGap: 20,
                        padding: Times.length > 3 && "5px 0px",
                      }}
                    >
                      {Times}
                    </div>
                  </div>

                  {Times.length > 3 ? (
                    <div
                      className="text-center"
                      style={{
                        position: "relative",
                        bottom: -2,
                        background: "white",
                      }}
                    >
                      <KeyboardArrowDownIcon style={{ color: "#7D7D7D" }} />
                    </div>
                  ) : (
                    <div style={{ marginBottom: 21, width: "100%" }}></div>
                  )}
                </>
              ))}

            {current_product.time_slots_style === 2 &&
              (!Times.length ? (
                language === "english" ? (
                  "Select your date first"
                ) : (
                  "يجب إختيار التاريخ اولا"
                )
              ) : (
                <>
                  <div
                    style={{
                      flexWrap: "wrap",
                      width: "100%",
                      flexDirection: "row",
                      display: "flex",
                      gap: 8,
                      justifyContent: language === "arabic" ? "right" : "left",
                      padding: Times.length > 3 && "5px 0px",
                    }}
                  >
                    {Times}
                  </div>
                  <div style={{ marginBottom: 21, width: "100%" }}></div>
                </>
              ))}

            {current_product.time_slots_style === 3 &&
              (!Times.length && !MorningTimes.length && !NightTimes.length ? (
                language === "english" ? (
                  "Select your date first"
                ) : (
                  "يجب إختيار التاريخ اولا"
                )
              ) : (
                <>
                  <div
                    style={{
                      flexWrap: "wrap",
                      width: "100%",
                      flexDirection: "row",
                      display: "flex",
                      gap: 8,
                      justifyContent: language === "arabic" ? "right" : "left",
                      padding: Times.length > 3 && "5px 0px",
                    }}
                  >
                    {Times}
                  </div>
                  {Times.length > 0 && (
                    <div style={{ marginBottom: 21, width: "100%" }}></div>
                  )}

                  {MorningTimes.length > 0 && (
                    <h4
                      className={`${
                        current_product.service_booking_style !== "calendar"
                          ? "mt-4"
                          : "my-2"
                      }  ${
                        language === "english" ? "text-left" : "text-right"
                      } `}
                      style={{
                        fontFamily:
                          language == "english" ? "Quicksand" : "Cairo",
                        color: timeError ? "" : "",
                      }}
                    >
                      {`${
                        language === "english"
                          ? customTexts.bookables_morning_shift
                          : customTexts.bookables_morning_shift_ar
                      }`}
                    </h4>
                  )}
                  <div
                    style={{
                      flexWrap: "wrap",
                      width: "100%",
                      flexDirection: "row",
                      display: "flex",
                      gap: 8,
                      justifyContent: language === "arabic" ? "right" : "left",
                      padding: Times.length > 3 && "5px 0px",
                    }}
                  >
                    {MorningTimes}
                  </div>
                  {MorningTimes.length > 0 && (
                    <div style={{ marginBottom: 21, width: "100%" }}></div>
                  )}
                  {NightTimes.length > 0 && (
                    <h4
                      className={`${
                        current_product.service_booking_style !== "calendar"
                          ? "mt-4"
                          : "my-2"
                      }  ${
                        language === "english" ? "text-left" : "text-right"
                      } `}
                      style={{
                        fontFamily:
                          language == "english" ? "Quicksand" : "Cairo",
                        color: timeError ? "" : "",
                      }}
                    >
                      {`${
                        language === "english"
                          ? customTexts.bookables_night_shift
                          : customTexts.bookables_night_shift_ar
                      }`}
                    </h4>
                  )}
                  <div
                    style={{
                      flexWrap: "wrap",
                      width: "100%",
                      flexDirection: "row",
                      display: "flex",
                      gap: 8,
                      justifyContent: language === "arabic" ? "right" : "left",
                      padding: Times.length > 3 && "5px 0px",
                    }}
                  >
                    {NightTimes}
                  </div>
                  <div style={{ marginBottom: 21, width: "100%" }}></div>
                </>
              ))}

            {current_product.time_slots_style === 0 &&
              this.state.ScrollAbleTime &&
              this.state.selectedDate !== -1 && (
                <div style={{ height: "auto" }}>
                  <ArrowForwardIosIcon
                    style={{}}
                    className="ml-1 my-auto pointer"
                    onClick={() =>
                      (this.Times_Container.current.container.current.scrollLeft += 100)
                    }
                  />
                </div>
              )}
          </div>
        </div>
      );
    else return null;
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.store.current_product,
    themeColor: state.store.store.settings.dark,
    customTexts: state.store.store.settings.custom_texts,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(ProductBookingSlot2);
